import _objectSpread from "/Users/victorgousset/Downloads/wetransfer_sources-sherlook_2022-11-20_0637/sherlook-b2c-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/Users/victorgousset/Downloads/wetransfer_sources-sherlook_2022-11-20_0637/sherlook-b2c-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var FormText = /*#__PURE__*/React.forwardRef(
// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'small' : _ref$as,
    muted = _ref.muted,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "as", "muted"]);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'form-text');
  return /*#__PURE__*/_jsx(Component, _objectSpread({}, props, {
    ref: ref,
    className: classNames(className, bsPrefix, muted && 'text-muted')
  }));
});
FormText.displayName = 'FormText';
export default FormText;